import type { CourseData, Course, DayFilter } from '../types/course';
import { format } from 'date-fns';

export function mergeCourseData(baseData: CourseData, savedData: CourseData | null): CourseData {
  if (!savedData) return baseData;

  const result = { ...baseData };

  // Helper function to find a saved course
  const findSavedCourse = (category: keyof CourseData, course: Course) => {
    if (!savedData[category]) return null;
    
    return savedData[category].find(sc => 
      sc.date === course.date && 
      sc.time === course.time && 
      sc.course_name === course.course_name
    );
  };

  // Process each category
  Object.keys(baseData).forEach(category => {
    const categoryKey = category as keyof CourseData;
    
    result[categoryKey] = baseData[categoryKey].map(course => {
      const savedCourse = findSavedCourse(categoryKey, course);
      return {
        ...course,
        selected: savedCourse ? true : false
      };
    });
  });

  return result;
}

export function getDayDate(day: DayFilter): string {
  const date = new Date();
  switch (day) {
    case 'tomorrow':
      date.setDate(date.getDate() + 1);
      break;
    case 'day after tomorrow':
      date.setDate(date.getDate() + 2);
      break;
  }
  return format(date, 'yyyy-MM-dd');
}